import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

// New pages open at the top; back/forward keeps the browser's position and #hash links scroll themselves.
export const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  const navType = useNavigationType();
  useEffect(() => {
    if (navType !== 'POP' && !hash) window.scrollTo(0, 0);
  }, [pathname, hash, navType]);
  return null;
};
